import type * as React from "react"

export const ThaiFlagMap = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={128}
    height={128}
    viewBox="0 0 128 128"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}
  >
    <defs>
      {/* soft drop shadow for the map */}
      <filter id="mapDrop" x="-20%" y="-20%" width="140%" height="140%">
        <feOffset dx="0" dy="2" in="SourceAlpha" result="off" />
        <feGaussianBlur in="off" stdDeviation="3" result="blur" />
        <feColorMatrix
          in="blur"
          type="matrix"
          values="0 0 0 0 0.03  0 0 0 0 0.12  0 0 0 0 0.23  0 0 0 0.45"
          result="shadow"
        />
        <feBlend in="SourceGraphic" in2="shadow" mode="normal" />
      </filter>

      {/* clip for the map - we use same path as mapShapePath */}
      <clipPath id="mapClip">
        <path
          id="mapShapePath"
          d="M66.5 11.5c6 0 12 1.5 17 4.5 5.8 3.6 9.3 8.6 11.2 12.8 1.6 3.7 1 7.1-1 9.6-2.1 2.7-5 4-7.5 4.7-2.8.8-4.2.4-6.6.2-2.6-.2-3.5 1.3-6.2 2.8-2.8 1.6-4.6 0-6.8 0-3.5 0-7.7 2.8-9.8 5.2-1.6 1.8-2.6 3.4-2.4 6 .2 3.5 2 6.7 3.6 9.7 2.3 4.3 2.6 7.2 1 9.8-2 3.3-6 6.6-9.3 9.1-3 2.2-5.6 2.8-9.1 2.6-3.8-.2-8-2-11-4.6-2.6-2.2-4.2-4.6-5.3-7.6-1.4-3.9-1.4-7.5-.2-11.6 1.6-5.9 5.6-12.1 8.1-16.5 2.4-4.1 3.1-6.8 3.1-10.6 0-4.9-2-9.8-4.6-14-2.5-4-6.2-7.5-7.2-13-.8-4.4 1-8.6 3.5-10.2 4.1-2.8 10.9-2.5 18.2-2.5zM73 86c1.2 2.8 2.6 5.6 5 7.2 2.9 1.9 6.4 1.6 9.2.3 2.8-1.3 5.4-3.9 7.6-6.1 2.2-2.2 3.8-4.7 3.8-7.2 0-2.2-1.4-3.8-3-4.6-1.5-.8-3.6-.8-6-.3-2.2.4-4.9 1.6-7 2.6-2 1-3.8 1.8-5 3.6-1.4 2-1.9 3.9-2.6 6z"
        />
      </clipPath>

      {/* simple rounded outline stroke style */}
      <style type="text/css">{`
        .ocean-lines { stroke-linecap: round; stroke-linejoin: round; }
      `}</style>
    </defs>

    {/* Outer ocean circle */}
    <circle
      cx="64"
      cy="64"
      r="60"
      fill="#A9E0FF"
      stroke="#1F4F88"
      strokeWidth="4"
    />

    {/* subtle decorative ocean "lines" (like in original) */}
    <g stroke="#3EA6E8" strokeWidth="3" className="ocean-lines" opacity="0.75">
      <line x1="22" y1="44" x2="45" y2="44" />
      <line x1="86" y1="36" x2="108" y2="36" />
      <line x1="30" y1="84" x2="54" y2="84" />
      <line x1="72" y1="92" x2="98" y2="92" />
      <line x1="92" y1="68" x2="118" y2="68" />
    </g>

    {/* Outer soft shadow behind the map (gives the slight 3D feel) */}
    <g filter="url(#mapDrop)">
      {/* a slightly darker, blurred duplicate to act like inner offset shadow */}
      <path
        d="M66.5 11.5c6 0 12 1.5 17 4.5 5.8 3.6 9.3 8.6 11.2 12.8 1.6 3.7 1 7.1-1 9.6-2.1 2.7-5 4-7.5 4.7-2.8.8-4.2.4-6.6.2-2.6-.2-3.5 1.3-6.2 2.8-2.8 1.6-4.6 0-6.8 0-3.5 0-7.7 2.8-9.8 5.2-1.6 1.8-2.6 3.4-2.4 6 .2 3.5 2 6.7 3.6 9.7 2.3 4.3 2.6 7.2 1 9.8-2 3.3-6 6.6-9.3 9.1-3 2.2-5.6 2.8-9.1 2.6-3.8-.2-8-2-11-4.6-2.6-2.2-4.2-4.6-5.3-7.6-1.4-3.9-1.4-7.5-.2-11.6 1.6-5.9 5.6-12.1 8.1-16.5 2.4-4.1 3.1-6.8 3.1-10.6 0-4.9-2-9.8-4.6-14-2.5-4-6.2-7.5-7.2-13-.8-4.4 1-8.6 3.5-10.2 4.1-2.8 10.9-2.5 18.2-2.5z"
        fill="#000000"
        fillOpacity="0.08"
        transform="translate(1,4)"
        stroke="none"
        strokeLinejoin="round"
      />
    </g>

    {/* Map base outline (thick rounded outline similar to original) */}
    <path
      d="M66.5 11.5c6 0 12 1.5 17 4.5 5.8 3.6 9.3 8.6 11.2 12.8 1.6 3.7 1 7.1-1 9.6-2.1 2.7-5 4-7.5 4.7-2.8.8-4.2.4-6.6.2-2.6-.2-3.5 1.3-6.2 2.8-2.8 1.6-4.6 0-6.8 0-3.5 0-7.7 2.8-9.8 5.2-1.6 1.8-2.6 3.4-2.4 6 .2 3.5 2 6.7 3.6 9.7 2.3 4.3 2.6 7.2 1 9.8-2 3.3-6 6.6-9.3 9.1-3 2.2-5.6 2.8-9.1 2.6-3.8-.2-8-2-11-4.6-2.6-2.2-4.2-4.6-5.3-7.6-1.4-3.9-1.4-7.5-.2-11.6 1.6-5.9 5.6-12.1 8.1-16.5 2.4-4.1 3.1-6.8 3.1-10.6 0-4.9-2-9.8-4.6-14-2.5-4-6.2-7.5-7.2-13-.8-4.4 1-8.6 3.5-10.2 4.1-2.8 10.9-2.5 18.2-2.5z"
      fill="#fff"
      stroke="#163A73"
      strokeWidth="4"
      strokeLinejoin="round"
      strokeLinecap="round"
    />

    {/* Flag stripes clipped to the Thailand map shape */}
    <g clipPath="url(#mapClip)">
      {/* top red stripe */}
      <rect x="38" y="12" width="52" height="20" fill="#E5242D" rx="0" />
      {/* white stripe */}
      <rect x="38" y="32" width="52" height="18" fill="#FFFFFF" rx="0" />
      {/* large blue stripe */}
      <rect x="38" y="50" width="52" height="30" fill="#184FB2" rx="0" />
      {/* lower white stripe (for southern isthmus) */
      /* extend the stripes downwards to cover the southern tail */}
      <rect x="38" y="80" width="52" height="24" fill="#FFFFFF" rx="0" />
      {/* bottom red stripe (southern tip) */}
      <rect x="38" y="100" width="52" height="28" fill="#E5242D" rx="0" />
    </g>

    {/* inner darker rim (thin inset) to simulate the original layered outline */}
    <path
      d="M66.5 11.5c6 0 12 1.5 17 4.5 5.8 3.6 9.3 8.6 11.2 12.8 1.6 3.7 1 7.1-1 9.6-2.1 2.7-5 4-7.5 4.7-2.8.8-4.2.4-6.6.2-2.6-.2-3.5 1.3-6.2 2.8-2.8 1.6-4.6 0-6.8 0-3.5 0-7.7 2.8-9.8 5.2-1.6 1.8-2.6 3.4-2.4 6 .2 3.5 2 6.7 3.6 9.7 2.3 4.3 2.6 7.2 1 9.8-2 3.3-6 6.6-9.3 9.1-3 2.2-5.6 2.8-9.1 2.6-3.8-.2-8-2-11-4.6-2.6-2.2-4.2-4.6-5.3-7.6-1.4-3.9-1.4-7.5-.2-11.6 1.6-5.9 5.6-12.1 8.1-16.5 2.4-4.1 3.1-6.8 3.1-10.6 0-4.9-2-9.8-4.6-14-2.5-4-6.2-7.5-7.2-13-.8-4.4 1-8.6 3.5-10.2 4.1-2.8 10.9-2.5 18.2-2.5z"
      fill="none"
      stroke="#12315A"
      strokeWidth="2"
      strokeLinejoin="round"
      opacity="0.7"
    />

    {/* small highlight edge on top-left of the map */}
    <path
      d="M56 17c2.6-.3 5.8-.6 8.5 0"
      stroke="#FFFFFF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity="0.6"
    />

    {/* small highlight at southern tail */}
    <path
      d="M73 86c1.2 2.8 2.6 5.6 5 7.2 2.9 1.9 6.4 1.6 9.2.3 2.8-1.3 5.4-3.9 7.6-6.1"
      stroke="#FFFFFF"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity="0.55"
      fill="none"
    />
  </svg>
)
